import _ from 'lodash'

export const PromiseWatch = () => {
  const _promises = {}
  const all = (key) =>  Promise.all(get(key))
  const first = (key) => _promises[key][0]
  const get = (key) => _promises[key] || []
  const has = (key) => !!_promises[key]
  const watch = (key, promise) => {
    _promises[key] = (_promises[key] || []).concat(promise)
    promise.finally(() => {
      _.remove(_promises[key], promise)
      if (_.isEmpty(_promises[key])) delete _promises[key]
    })
    return promise
  }
  return {
    all, 
    first, 
    get,
    has, 
    watch, 
  }
}

type PromiseThunk = () => Promise<any>
type WrappedPromise = {
  fulfilled: boolean,
  promise: Promise<any>
}
const wrapPromise = (promise): WrappedPromise => {
  const fn = () => wrapped.fulfilled = true
  const wrapped = {
    fulfilled: false,
    promise
  }
  promise.then(fn, fn)
  return wrapped
}

export const parallel = async (pthunks: PromiseThunk[], n:number) => {
  let ws: WrappedPromise[] = []

  while(true) {
    if (_.isEmpty(pthunks)) break
    while (pthunks.length > 0 && _.sumBy(ws, w => !w.fulfilled) < n) {
      const pt = pthunks.shift()
      ws.push(wrapPromise(pt && pt()))
    }
    await Promise.race(ws.filter(w => !w.fulfilled).map(w => w.promise))
  }

  let result:any[] = []
  for (const w of ws) {
    result.push(await w.promise)
  }
  return result
}  
